import { render, staticRenderFns } from "./NewDescription.vue?vue&type=template&id=2e7b7141&"
import script from "./NewDescription.vue?vue&type=script&lang=js&"
export * from "./NewDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports